import {Avatar, AvatarGroup} from '@sollapay/ui/components';

import {getInitials} from '@/utils/get-initials.utils';

import type {TrustAccountListSellerDTO} from '@sollapay/types';
import type {ComponentProps, FC} from 'react';

export interface SellerAvatarStackProps {
  sellers: Pick<TrustAccountListSellerDTO, 'id' | 'fullName'>[];
  size?: ComponentProps<typeof Avatar>['size'];
  className?: string;
}

/** Overlapping avatars for a seller roster; `AvatarGroup` caps the stack and adds the `+N` chip. */
export const SellerAvatarStack: FC<SellerAvatarStackProps> = ({sellers, size, className}) => (
  <AvatarGroup size={size} className={className}>
    {sellers.map(seller => (
      <Avatar
        key={seller.id}
        initials={getInitials(seller.fullName)}
        size={size}
        seed={seller.id}
        noShadow
      />
    ))}
  </AvatarGroup>
);
